export default __webpack_public_path__ + "static/media/excel.2642888b.svg";